import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Select from '../../../1stlog-ui/src/components/Select'
import LoaderOverlay from '../../../1stlog-ui/src/components/LoaderOverlay'

const Wrapper = styled.div`
  position: relative;
  width: 250px;
`

const TenantSwitcher = (props) => {
  const { tenants = [] } = props

  const [isLoading, setIsLoading] = useState(false)

  if (lodash.size(tenants) < 2) {
    return null
  }

  const selectedTenant = String(
    lodash.get(
      lodash.find(tenants, (tenant) => tenant.active),
      'id'
    )
  )

  const options = lodash.reduce(tenants, (result, { name, id }) => ({ ...result, [id]: name }), {})

  const onChange = (id) => {
    setIsLoading(true)
    window.location.href = `/settings/switch/tenant/${id}`
  }
  // const onChange = async id => {
  //   try {
  //     setIsLoading(true)
  //     await request({ url: `/settings/switch/tenant/${id}`, method: "get" })
  //     toast.success(i18n.t("page_is_loading_please_wait", "Diese Seite wird neu geladen. Bitte warten..."))
  //     window.location.reload()
  //   } catch (err) {
  //     console.error("Failed to switch tenant", err)
  //     toast.error("Wechsel des Kunden fehlgeschlagen!")
  //   } finally {
  //     setIsLoading(false)
  //   }
  // }

  return (
    <Wrapper>
      <LoaderOverlay isLoading={isLoading} fullscreen>
        {i18n.t('customer_is_changing', 'Bitte warten während der Kunde gewechselt wird...')}
      </LoaderOverlay>
      <Select value={selectedTenant} options={options} onChange={onChange} direct />
    </Wrapper>
  )
}

export default TenantSwitcher
